import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import SlidingPlayMistBackground from "../../../pages/puzzles/sliding/SlidingPlayMistBackground";
import ColorBasketFeatureShot from "../components/ColorBasketFeatureShot";
import { getImageUrl, getStoryTitle, getTemplateGrid } from "../lib/api";
import { loadColorBasketDemoPuzzle } from "../lib/colorBasketDemo";
import { RECORDING_FRAME_GOOGLE_1080P } from "../recordingCaptureFrame";
import { useCaptureFrameViewport } from "../useCaptureFrameViewport";

const FRAME = RECORDING_FRAME_GOOGLE_1080P;

/** Prototype-only 1920×1080 Color Basket feature shot (still frame for trailers/store art). */
export default function Recording1080pColorBasketFeaturePage() {
    useCaptureFrameViewport(FRAME.width, FRAME.height);

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            setLoading(true);
            setError(null);
            try {
                const loaded = await loadColorBasketDemoPuzzle();
                if (!cancelled) setData(loaded);
            } catch (e) {
                if (!cancelled) setError(e?.message || "Failed to load the color basket feature");
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const grid = getTemplateGrid(data?.template) || 0;

    return (
        <Box
            sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: FRAME.width,
                height: FRAME.height,
                overflow: "hidden",
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "column",
                bgcolor: "#c5d5ce",
            }}
        >
            <SlidingPlayMistBackground />
            <Box
                sx={{
                    position: "relative",
                    zIndex: 1,
                    flex: 1,
                    minHeight: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                {loading ? (
                    <CircularProgress size={44} sx={{ color: "#3BA666" }} />
                ) : error || !data ? (
                    <Typography color="error" variant="h5">
                        {error || "Color basket feature is not available for this puzzle"}
                    </Typography>
                ) : (
                    <ColorBasketFeatureShot
                        baskets={data.baskets}
                        imageUrl={getImageUrl(data.story)}
                        grid={grid}
                        puzzleTitle={getStoryTitle(data.story)}
                    />
                )}
            </Box>
        </Box>
    );
}
